/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupportSetReferralOriginRequest
 */
export interface SupportSetReferralOriginRequest {
    /**
     * 
     * @type {string}
     * @memberof SupportSetReferralOriginRequest
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof SupportSetReferralOriginRequest
     */
    originType: SupportSetReferralOriginRequestOriginTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SupportSetReferralOriginRequest
     */
    identifier?: string | null;
}


/**
 * @export
 */
export const SupportSetReferralOriginRequestOriginTypeEnum = {
    None: 'none',
    Referrer: 'referrer',
    Promotion: 'promotion'
} as const;
export type SupportSetReferralOriginRequestOriginTypeEnum = typeof SupportSetReferralOriginRequestOriginTypeEnum[keyof typeof SupportSetReferralOriginRequestOriginTypeEnum];


/**
 * Check if a given object implements the SupportSetReferralOriginRequest interface.
 */
export function instanceOfSupportSetReferralOriginRequest(value: object): value is SupportSetReferralOriginRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('originType' in value) || value['originType'] === undefined) return false;
    return true;
}

export function SupportSetReferralOriginRequestFromJSON(json: any): SupportSetReferralOriginRequest {
    return SupportSetReferralOriginRequestFromJSONTyped(json, false);
}

export function SupportSetReferralOriginRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportSetReferralOriginRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'originType': json['origin_type'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
    };
}

export function SupportSetReferralOriginRequestToJSON(json: any): SupportSetReferralOriginRequest {
    return SupportSetReferralOriginRequestToJSONTyped(json, false);
}

export function SupportSetReferralOriginRequestToJSONTyped(value?: SupportSetReferralOriginRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'origin_type': value['originType'],
        'identifier': value['identifier'],
    };
}

